import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";
import { FaStar } from 'react-icons/fa';

import Rajamohan from './images/rajamohan.jpg';
import Arvind from './images/ArvindBatra.jpeg';
import leonardo from './images/leonardo.jpeg';
import Mark from './images/mark.jpg';
import sachin from './images/sachin_gujar.jpg';

interface TestimonialData {
  id: number;
  name: string;
  position: string;
  content: string;
  image: string;
  review: number;
}

const defaultSliders: TestimonialData[] = [
  {
    id: 1,
    name: 'Rajamohan Dhandapani',
    position: 'Chair - RMB International',
    content: 'Rotary Means Business Jaipur has been a game-changer for my business. The networking opportunities are incredible, and I have built strong connections that have directly led to new clients and collaborations.',
    image: Rajamohan,
    review: 5
  },
  {
    id: 2,
    name: 'Arvind Kumar Batra',
    position: 'Vice Chair - RMB Jaipur',
    content: 'The monthly meetups are well-structured, and the members are truly supportive. It is an excellent platform for anyone looking to grow their business while building lasting relationships.',
    image: Arvind,
    review: 5
  },
  {
    id: 3,
    name: 'Leonardo Santos',
    position: 'Secretary - RMB International',
    content: 'I have gained so much from Rotary Means Business Jaipur. The events provide valuable insights into business strategies, and the network has helped me take my business to the next level.',
    image: leonardo,
    review: 5
  },
  {
    id: 4,
    name: 'Mark Burchill',
    position: 'Chair Emeritus & Treasurer',
    content: 'Joining Rotary Means Business Jaipur was one of the best decisions I have made. The community is welcoming, and I have seen a significant boost in my business through the connections I have made.',
    image: Mark,
    review: 5
  },
  {
    id: 5,
    name: 'Sachin Gururaj',
    position: 'Chair Emeritus & Immediate Past Chair',
    content: 'The platform fosters a professional yet friendly environment where business owners can thrive. I have enjoyed the discussions, and the networking has been truly beneficial for my growth.',
    image: sachin,
    review: 5
  }
];

const Testomonail = () => {
  const [testimonialdata, setTestimonialdata] = useState<TestimonialData[]>(defaultSliders);
  const [activeslider, setSlider] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<TestimonialData[]>(
          "https://rmbbackend.rmbjaipur.com/auth/testimonial"
        );
        if (Array.isArray(response.data) && response.data.length > 0) {
          const transformedSliders = response.data.map((slider) => ({
            ...slider,
            image: slider.image
              ? (slider.image.startsWith('http')
                  ? slider.image
                  : `https://rmbbackend.rmbjaipur.com/${slider.image.replace(/\\/g, '/')}`)
              : Rajamohan,
            review: Number(slider.review) || 5,
          }));
          setTestimonialdata(transformedSliders);
        }
      } catch {
        // Fallback to defaultSliders on error
      }
    };

    fetchData();
  }, []);

  const total = testimonialdata.length;
  const currentItem = testimonialdata[activeslider % (total || 1)];

  const handlePrevious = () => {
    setSlider((prevIndex) => (prevIndex === 0 ? total - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setSlider((prevIndex) => (prevIndex + 1) % total);
  };

  if (!currentItem) return null;

  return (
    <div className='relative min-h-[320px]'>
      <div className='w-full h-full bg-[#101729] border border-[#465468] rounded-2xl p-6 sm:p-10 relative overflow-hidden shadow-2xl'>
        <div className="main-container flex flex-col gap-4">

          {/* Slider Header */}
          <div className="flex flex-col md:flex-row justify-start items-center text-center md:text-left z-30 space-y-4 md:space-y-0 md:space-x-6">
            <div className="w-[84px] h-[84px] md:w-[110px] md:h-[110px] rounded-full border-2 border-[#FDBC12] overflow-hidden flex-shrink-0 shadow-lg bg-slate-900">
              <img
                className="w-full h-full object-cover"
                src={currentItem.image}
                alt={currentItem.name}
                onError={(e) => { e.currentTarget.src = Rajamohan; }}
              />
            </div>

            <div className="flex flex-col items-center md:items-start space-y-1">
              <h3 className="text-xl md:text-2xl font-black text-white leading-tight">
                {currentItem.name}
              </h3>
              <p className="text-xs md:text-sm font-semibold text-[#FDBC12]">
                {currentItem.position}
              </p>
              <div className="flex items-center gap-1 text-amber-400 text-sm pt-1">
                {[...Array(Math.min(5, Math.max(1, currentItem.review || 5)))].map((_, i) => (
                  <FaStar key={i} />
                ))}
              </div>
            </div>
          </div>

          {/* Testimonial Quote */}
          <p className="z-30 text-sm md:text-base text-slate-300 leading-relaxed pt-2">
            "{currentItem.content}"
          </p>

          {/* Counter / Dots */}
          <div className="flex justify-between items-center pt-4 border-t border-slate-700/60 mt-2">
            <span className="text-xs text-slate-400 font-semibold">
              {activeslider + 1} of {total}
            </span>
            <div className="flex items-center gap-1.5">
              {testimonialdata.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setSlider(idx)}
                  className={`h-2 rounded-full transition-all cursor-pointer ${
                    activeslider === idx ? 'w-6 bg-[#FDBC12]' : 'w-2 bg-slate-700 hover:bg-slate-500'
                  }`}
                  aria-label={`Go to slide ${idx + 1}`}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Previous Button */}
        <button
          onClick={handlePrevious}
          className="absolute left-2 sm:-left-3 top-1/2 -translate-y-1/2 z-40 bg-[#1E2B45] border border-slate-600 hover:border-[#FDBC12] text-white hover:text-[#FDBC12] w-9 h-9 sm:w-10 sm:h-10 flex justify-center items-center rounded-full shadow-xl transition cursor-pointer"
          aria-label="Previous testimonial"
        >
          <RiArrowLeftSLine size={24} />
        </button>

        {/* Next Button */}
        <button
          onClick={handleNext}
          className="absolute right-2 sm:-right-3 top-1/2 -translate-y-1/2 z-40 bg-[#1E2B45] border border-slate-600 hover:border-[#FDBC12] text-white hover:text-[#FDBC12] w-9 h-9 sm:w-10 sm:h-10 flex justify-center items-center rounded-full shadow-xl transition cursor-pointer"
          aria-label="Next testimonial"
        >
          <RiArrowRightSLine size={24} />
        </button>
      </div>
    </div>
  );
};

export default Testomonail;